import React, { useState, useEffect } from 'react';
import { useWeb3 } from '../../contexts/Web3Context';
import { useUI } from '../../contexts/UIContext';
import { ethers } from 'ethers';

const DirectReferrals = () => {
  const { userId, grichInvContract, shortenAddress } = useWeb3();
  const { showLoading, hideLoading, showModal } = useUI();
  const [directRefs, setDirectRefs] = useState([]);
  const [directStats, setDirectStats] = useState({
    count: 0,
    business: '0',
    earnings: '0'
  });

  useEffect(() => {
    if (userId > 0 && grichInvContract) {
      loadDirectReferrals();
    }
  }, [userId, grichInvContract]);

  const loadDirectReferrals = async () => {
    try {
      showLoading('Loading direct referrals...');
      
      // Get user's info to check refCount
      const userInfo = await grichInvContract.usersInfo(userId);
      const userRefCount = parseInt(userInfo.refCount.toString());
      
      if (userRefCount > 0) {
        // Get all users to filter for direct referrals
        const allUsers = await grichInvContract.getAllUsers();
        
        // Filter users where ref matches the current userId
        const directReferrals = allUsers.filter(user => 
          parseInt(user.ref.toString()) === userId
        );
        
        setDirectRefs(directReferrals);
        
        // Calculate direct business from the filtered users
        let directBusiness = ethers.BigNumber.from(0);
        for (const ref of directReferrals) {
          directBusiness = directBusiness.add(ref.totalDepositUSDT);
        }
        
        // Get direct ref percentage for earnings calculation
        const directPercent = await grichInvContract.directRefPercent();
        const directEarnings = directBusiness.mul(directPercent).div(100);
        
        // Update stats
        setDirectStats({
          count: directReferrals.length,
          business: directBusiness.toString(),
          earnings: directEarnings.toString()
        });
      } else {
        // No direct referrals
        setDirectRefs([]);
        setDirectStats({ count: 0, business: '0', earnings: '0' });
      }
      
      hideLoading();
    } catch (error) {
      console.error('Error loading direct referrals:', error);
      hideLoading();
      showModal('Error', 'Failed to load direct referrals. Please try again.');
    }
  };

  // Format a BigNumber as USDT with 2 decimal places
  const formatUSDT = (amount) => {
    return `${parseFloat(ethers.utils.formatUnits(amount, 18)).toFixed(2)} USDT`;
  };

  return (
    <div className="team-tab-content active" id="direct">
      <div className="team-metrics-bar">
        <div className="team-metric">
          <div className="metric-value">{directStats.count}</div>
          <div className="metric-label">Direct Referrals</div>
        </div>
        <div className="team-metric">
          <div className="metric-value">{formatUSDT(directStats.business)}</div>
          <div className="metric-label">Direct Business</div>
        </div>
        <div className="team-metric">
          <div className="metric-value">{formatUSDT(directStats.earnings)}</div>
          <div className="metric-label">Direct Earnings</div>
        </div>
      </div>
      
      <div className="team-table-container">
        <table className="team-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Wallet</th>
              <th>Investment</th>
              <th>Team Size</th>
            </tr>
          </thead>
          <tbody>
            {directRefs.length > 0 ? (
              directRefs.map((ref, index) => (
                <tr key={index}>
                  <td>{parseInt(ref.id.toString())}</td>
                  <td>{shortenAddress(ref.acct)}</td>
                  <td>{formatUSDT(ref.totalDepositUSDT)}</td>
                  <td>{parseInt(ref.totalMatrixTeam.toString())}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="4" style={{ textAlign: 'center' }}>No direct referrals yet</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default DirectReferrals;
